export class OfflineAPI {
    constructor(gameMath, gameConfig) {}

    async player(parameters) {}

    async spin({ bet }) {}

    async freeSpin({ hash }) {}
    async randomDelay() {
        const delay = Math.floor(Math.random() * 1000);

        return new Promise(resolve => {
            setTimeout(resolve, delay);
        });
    }

    async getPayTable({ bet }) {}

    clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
}
